export * from './LegalInfoPage';
